<div class="as-expired-main-container">
  <div class="as-top-container">
    <div class="as-closebtn">
      <mat-icon
        (click)="closeModal(false)"
        class="as-pointer"
        svgIcon="ic-close-gray"
      >
      </mat-icon>
    </div>
    <div class="as-title">Promociones expiradas</div>
    <div class="as-description">
      Estas promociones no aplican para tu horario seleccionado. Cambia el día o
      ajusta tu carrito.
    </div>
  </div>
  <div class="as-products-container">
    <div class="as-product-item">
      @for (item of productList; track $index) {
      <div class="as-item-expired">
        <div
          class="as-item-image"
          [ngStyle]="{ 'background-image': 'url(' + item.image + ')' }"
        ></div>
        <p class="as-promo-name">{{ item.product.description }}</p>
      </div>

      }
    </div>
  </div>
  <div class="as-bottom-container">
    <div class="as-label">
      Si continúas, tu pedido se procesará sin descuento.
    </div>
    <div class="as-buttons-container">
      <div class="white-button">
        <button
          mat-flat-button
          color="accent"
          class="white-button"
          (click)="closeModal(true)"
        >
          <mat-label class="as-font as-font-semibold as-pointer">
            Regresar al carrito
          </mat-label>
        </button>
      </div>
      <div class="green-button">
        <button
          mat-flat-button
          class="green-button"
          color="accent"
          (click)="closeModal(false)"
        >
          <mat-label class="as-font as-font-white as-font-semibold as-pointer">
            Continuar compra
          </mat-label>
        </button>
      </div>
    </div>
  </div>
</div>
